/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Bump,
    BumpFromJSON,
    BumpFromJSONTyped,
    BumpToJSON,
    SdsBackendFlavor,
    SdsBackendFlavorFromJSON,
    SdsBackendFlavorFromJSONTyped,
    SdsBackendFlavorToJSON,
} from './';

/**
 * 
 * @export
 * @interface SessionInitData
 */
export interface SessionInitData {
    /**
     * 
     * @type {string}
     * @memberof SessionInitData
     */
    sessionId: string;
    /**
     * 
     * @type {Array<Bump>}
     * @memberof SessionInitData
     */
    bumps: Array<Bump>;
    /**
     * 
     * @type {string}
     * @memberof SessionInitData
     */
    composedUrl: string;
    /**
     * 
     * @type {string}
     * @memberof SessionInitData
     */
    guiResourcesUrl: string;
    /**
     * 
     * @type {number}
     * @memberof SessionInitData
     */
    resetTimeSec: number;
    /**
     * 
     * @type {SdsBackendFlavor}
     * @memberof SessionInitData
     */
    backendFlavor: SdsBackendFlavor;
}

export function SessionInitDataFromJSON(json: any): SessionInitData {
    return SessionInitDataFromJSONTyped(json, false);
}

export function SessionInitDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SessionInitData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sessionId': json['sessionId'],
        'bumps': ((json['bumps'] as Array<any>).map(BumpFromJSON)),
        'composedUrl': json['composedUrl'],
        'guiResourcesUrl': json['guiResourcesUrl'],
        'resetTimeSec': json['resetTimeSec'],
        'backendFlavor': SdsBackendFlavorFromJSON(json['backendFlavor']),
    };
}

export function SessionInitDataToJSON(value?: SessionInitData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sessionId': value.sessionId,
        'bumps': ((value.bumps as Array<any>).map(BumpToJSON)),
        'composedUrl': value.composedUrl,
        'guiResourcesUrl': value.guiResourcesUrl,
        'resetTimeSec': value.resetTimeSec,
        'backendFlavor': SdsBackendFlavorToJSON(value.backendFlavor),
    };
}


